import React, { useEffect } from 'react';
import './DisasterMessagesSearch.css';

const DisasterMessageSearch = ({
  searchParams,
  onSearchParamsChange,
  onFilterChange,
  onSearch,
  onResetFilters,
  onReset
}) => {
  // 컴포넌트 렌더링 시 전달된 props 로깅
  useEffect(() => {
    console.log('DisasterMessageSearch props:', {
      searchParams
    });
  }, [searchParams]);

  // 입력 변경 핸들러
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log('검색 파라미터 변경:', name, value);
    onSearchParamsChange({ [name]: value });
  };

  // 필터 변경 핸들러
  const handleFilterChange = (e) => {
    const { name, value, type, checked } = e.target;
    const filterValue = type === 'checkbox' ? checked : value;
    console.log('필터 변경:', name, filterValue);
    onFilterChange({
      [name]: filterValue
    });
  };

  // 검색 제출 핸들러
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('검색 실행');
    onSearch();
  };

  // API 형식으로 날짜 변환 (YYYY-MM-DD -> YYYYMMDD)
  const formatDateForApi = (htmlDate) => {
    if (!htmlDate) return '';
    return htmlDate.replace(/-/g, '');
  };

  // HTML 날짜 입력 형식으로 변환 (YYYYMMDD -> YYYY-MM-DD)
  const formatDateForInput = (apiDate) => {
    if (!apiDate || apiDate.length !== 8) return '';
    return `${apiDate.substring(0, 4)}-${apiDate.substring(4, 6)}-${apiDate.substring(6, 8)}`;
  };

  // 날짜 입력 변경 핸들러
  const handleDateChange = (e) => {
    const htmlDate = e.target.value;
    const apiDate = htmlDate ? formatDateForApi(htmlDate) : '';
    console.log('날짜 변경:', htmlDate, '->', apiDate);
    onSearchParamsChange({
      crtDt: apiDate
    });
  };

  return (
    <div className="search-panel disaster-search-panel">
      <form onSubmit={handleSubmit} className="search-form">
        <div className="search-group api-params">
          <h3 className="search-group-title">API 검색 파라미터</h3>
          <div className="search-row">
            <div className="form-group">
              <label htmlFor="crtDt">조회일자:</label>
              <input
                type="date"
                id="crtDt"
                name="crtDt"
                value={formatDateForInput(searchParams.crtDt)}
                onChange={handleDateChange}
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label htmlFor="rgnNm">지역명:</label>
              <input
                type="text"
                id="rgnNm"
                name="rgnNm"
                value={searchParams.rgnNm}
                onChange={handleInputChange}
                placeholder="예: 서울특별시, 울산광역시"
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label htmlFor="numOfRows">표시 개수:</label>
              <select
                id="numOfRows"
                name="numOfRows"
                value={searchParams.numOfRows}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="10">10개</option>
                <option value="20">20개</option>
                <option value="50">50개</option>
                <option value="100">100개</option>
              </select>
            </div>
          </div>
        </div>

        <div className="search-group filters">
          <h3 className="search-group-title">상세 필터</h3>
          <div className="search-row">
            <div className="form-group">
              <label htmlFor="keyword">키워드:</label>
              <input
                type="text"
                id="keyword"
                name="keyword"
                value={searchParams.filters?.keyword || ''}
                onChange={handleFilterChange}
                placeholder="메시지 내용 검색"
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label htmlFor="agency">발신 기관:</label>
              <input
                type="text"
                id="agency"
                name="agency"
                value={searchParams.filters?.agency || ''}
                onChange={handleFilterChange}
                placeholder="예: 경찰청, 행정안전부"
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label htmlFor="region">세부 지역:</label>
              <input
                type="text"
                id="region"
                name="region"
                value={searchParams.filters?.region || ''}
                onChange={handleFilterChange}
                placeholder="상세 지역 필터링"
                className="form-control"
              />
            </div>
          </div>

          <div className="search-row">
            <div className="form-group checkbox-group">
              <input
                type="checkbox"
                id="missingPersonOnly"
                name="missingPersonOnly"
                checked={searchParams.filters?.missingPersonOnly || false}
                onChange={handleFilterChange}
              />
              <label htmlFor="missingPersonOnly">실종자 관련 메시지만 표시</label>
              <span className="checkbox-hint">* 실종자 관련 메시지: 경찰청, 경찰서에서 발송한 실종자 찾기 메시지</span>
            </div>
          </div>
        </div>

        <div className="button-group">
          <button type="submit" className="search-button">검색</button>
          <button type="button" className="filter-reset-button" onClick={onResetFilters}>필터 초기화</button>
          <button type="button" className="reset-button" onClick={onReset}>전체 초기화</button>
        </div>
      </form>

      <div className="search-tips">
        <h3>검색 팁:</h3>
        <ul>
          <li>조회일자를 지정하여 특정 날짜의 재난문자를 검색할 수 있습니다. (오늘 날짜로 자동 설정됩니다)</li>
          <li>지역명을 입력하여 특정 지역의 재난문자만 조회할 수 있습니다. (예: <strong>울산광역시</strong>)</li>
          <li>키워드 필터를 사용하여 <strong>산불</strong>, <strong>지진</strong>, <strong>태풍</strong> 등 특정 키워드가 포함된 메시지를 검색할 수 있습니다.</li>
          <li>실종자 관련 메시지만 표시 옵션을 선택하면 경찰청에서 발송된 실종자 관련 메시지만 필터링됩니다.</li>
          <li>검색 결과는 최신순으로 정렬됩니다.</li>
        </ul>
      </div>
    </div>
  );
};

export default DisasterMessageSearch;